import type { AvatarDesignTokens, AvatarTokenSections } from '@openng/optimus-ui-themes/types/avatar';

export const root: AvatarTokenSections.Root = {
	background: '{primary.color}',
	color: '{primary.contrast.color}',
};

export const lg: AvatarTokenSections.Lg = {
	width: '2.75rem',
	height: '2.75rem',
	fontSize: '1rem',
};

export const xl: AvatarTokenSections.Xl = {
	width: '4.5rem',
	height: '4.5rem',
	fontSize: '1.625rem',
};

export default {
	root,
	lg,
	xl,
} satisfies AvatarDesignTokens;
